import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./catalog.scss";
import { UnSetdataTable } from "../common/api/setdatatable";
import CheckoutSell from "../checkout/checkoutSell";
import CheckoutBlank from "../checkout/checkoutBlank";
import ProductListGrid from "../common/productList/productListGrid";
import ProductListTable from "../common/productList/productListTable";
import { _Api } from "../common/api/_call";
import CatalogNavbar, { CATALOG_SUBCATEGORY_NAV_IDS } from "./CatalogNavbar";
import CatalogAllProducts from "./collection/CatalogAllProducts";
import CatalogProductsToolbarSection from "./collection/CatalogProductsToolbarSection";
import {
  DEFAULT_CATALOG_FILTERS,
  createCatalogFiltersForSubCategory,
  sortByToSale,
} from "./collection/catalogAllFilterUtils";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../common/module/Loading/Loading";
import CheckoutPayment from "../checkout/checkoutPayment";
import NoOrdersYet from "../common/module/NoOrdersYet/NoOrdersYet";
import { useTranslation } from "react-i18next";
import { updatePosState } from "source/app/appSlice";
import { toast } from "react-toastify";
import faromainicon from "../../assets/images/faromainicon.svg";
import ExportOptionModal from "../../components/common/ExportOptionModal";

const Products = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const navigate = useNavigate();
  const posOrgSettings = useSelector((state) => state.app.posorganisation_settings);
  const isFaroActive = posOrgSettings?.faro_active === 1;
  const handleFaroClick = (e) => {
    if (!isFaroActive) {
      e.preventDefault();
      toast.error(t("Please activate Claude and Voyage both in Settings > Integrated Applications"));
    }
  };
  const [pNavid, setproductNavid] = useState();
  const [isviewOption, setIsviewOption] = useState(false);
  const { state } = useLocation();
  const [searchsku, setSearchsku] = useState();
  const [skip, setSkip] = useState(0);
  const [, setdeletestatus] = useState(false);
  const [Totalproduct, setTotalproduct] = useState(0);
  const [showcheckout, setShowcheckout] = useState(
    localStorage.getItem("showcheckout") || "blank",
  );
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const checksale =
    localStorage.getItem("showcheckout") === "sell" ? true : false;
  const [searchproductstatus, setsearchproductstatus] = useState(
    checksale || false,
  );
  const [Sale, setSale] = useState("top_sale");
  const [productlist, setProductlist] = useState();
  const [isCrown, setCrown] = useState(
    state?.Optiondetails === true ? true : false,
  );
  const [inv_orderid, setInv_orderid] = useState();
  const [inv_ordertype, setInv_ordertype] = useState();
  const [by_repair_order, setBy_repair_order] = useState();
  const [by_customorder, setBy_customorder] = useState();
  const customer = useSelector((state) => state.app.customer);
  const [Loadingstatus, setLoadingstatus] = useState(false);
  const [shoremorelodar, setShowmorelodar] = useState(false);
  const [addparmission, setAddparmission] = useState(0);
  const [custom_data, setCustom_data] = useState();
  const [finalprodata, setFinalprodata] = useState([]);
  const [cartstockid, setCartstockid] = useState();
  const [uuid, setUuid] = useState("");
  const [stockid, setStockid] = useState("");
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [downloading, setDownloading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const itemdaata = localStorage.getItem("itemdata");
  const customerdata = localStorage.getItem("addcustomerdtaa");
  const parsedItem = itemdaata ? JSON.parse(itemdaata) : null;
  const parsedCustomer = customerdata ? JSON.parse(customerdata) : null;
  const parsedObject = {
    item: parsedItem,
    customer: parsedCustomer,
  };

  const isIcsTab = CATALOG_SUBCATEGORY_NAV_IDS.includes(state?.NavId);
  const [icsListView, setIcsListView] = useState(false);
  const [appliedCatalogFilters, setAppliedCatalogFilters] = useState(() =>
    CATALOG_SUBCATEGORY_NAV_IDS.includes(state?.NavId) && state?.itemid
      ? createCatalogFiltersForSubCategory(state?.NavId, state?.itemid)
      : DEFAULT_CATALOG_FILTERS,
  );
  const prevIcsSelectionRef = useRef(
    `${state?.NavId || ''}:${state?.itemid || ''}`,
  );

   const generateUuid = () => {
    const newUuid = crypto.randomUUID();
    setUuid(newUuid);
  };
  useEffect(() => {
    if (parmissiondatashow?.POS?.View || parmissiondatashow?.WishList?.View)
      setAddparmission(parmissiondatashow?.POS?.Add);
  }, [parmissiondatashow]);

  useEffect(() => {
    if (!isIcsTab || !state?.itemid) return;
    const selectionKey = `${state.NavId}:${state.itemid}`;
    if (prevIcsSelectionRef.current === selectionKey) return;
    prevIcsSelectionRef.current = selectionKey;
    setAppliedCatalogFilters(
      createCatalogFiltersForSubCategory(state.NavId, state.itemid),
    );
  }, [isIcsTab, state?.NavId, state?.itemid]);

  const crownClick = () => {
    setCrown((current) => !current);
    if (!isIcsTab) {
      setSkip(0);
    }
  };

  const setproductdata = (productid, name, item) => {
    const data = {
      productid,
      filter: isCrown,
      itemname: name,
      itemid: item,
      NavId: state?.NavId,
      parkid: state?.parkid || "",
      order_id: state?.order_id || "",
      order_type: state?.order_type || "",
      order_edit: state?.order_edit || false,
    };
    localStorage.setItem("productdata", JSON.stringify(data));
  };

  const getproducts = async () => {
    UnSetdataTable("pos_order_table");
    if (!shoremorelodar) {
      setLoadingstatus(true);
    }
    try {
      const postdata = {
        Item_id: state?.itemid ? state?.itemid : parsedObject?.item?.Item_id,
        type: isCrown === true ? "catalog" : "inventory",
        limit: 20,
        skip: skip,
        sale: Sale,
        search: searchsku ? searchsku : state?.search,
        category_id: state?.NavId
          ? state?.NavId
          : parsedObject?.item?.category_id,
        customer_id: customer?.id ? customer?.id : "",
      };
      localStorage.setItem("itemdata", JSON.stringify(postdata));
      const res = await _Api(postdata, `api/v1/POS/home/itemData`);
      if (res.code === 200) {
        generateUuid();
        if (res?.data?.length || res?.soldOutOrder?.length) {
          if (skip === 0) {
            setCustom_data(res?.soldOutOrder);
            const finalData = (res?.soldOutOrder || []).concat(res?.data || []);
            setFinalprodata(finalData);
            setProductlist(res?.data);
          } else {
            setCustom_data((prev) => [
              ...(prev || []),
              ...(res?.soldOutOrder || []),
            ]);
            setProductlist((prev) => [...(prev || []), ...(res?.data || [])]);
            setFinalprodata((prev) => [
              ...prev,
              ...(res?.soldOutOrder || []),
              ...(res?.data || []),
            ]);
          }
        } else {
          setProductlist([]);
          setFinalprodata([]);
          setCustom_data([]);
        }
        setTotalproduct(res?.total);
        if (shoremorelodar) {
          setShowmorelodar(false);
        } else {
          setLoadingstatus(false);
        }
      } else {
        setIsviewOption(false);
        setTotalproduct(res?.total);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const filterbyname = () => {
    setSkip(0);
    getproducts();
  };

  const GetCartdetailpark = async () => {
    try {
      let postdata;
      if (state?.parkid || state?.order_id) {
        postdata = {
          park_id: state?.parkid,
          order_id: state?.order_id,
        };
      } else {
        postdata = {};
      }

      const res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setShowcheckout("sell");
      } else {
        navigate("/app/pos/catalog/CollectionList");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const downlodPrintPDF = async (kind = "catalog") => {
    try {
      setDownloading(true);
      // Do not block PDF export when customer address is missing.
      // Backend fills store/location address for any empty customer fields.
      const postdata = {
        Item_id: state?.itemid ? state?.itemid : parsedObject?.item?.Item_id,
        type: isCrown === true ? "catalog" : "inventory",
        category_id: state?.NavId
          ? state?.NavId
          : parsedObject?.item?.category_id,
        customer_id: customer?.id ? customer?.id : "",
        shippingInfo: parsedObject?.customer || customer || "",
        website_url: window.location.hostname,
      };

      // const res = await _Api(postdata, `api/v1/POS/customOrder/getCatalogPdf`);
      const res = await _Api(
        postdata,
        kind === "detail"
          ? `api/v1/POS/customOrder/productDetail`
          : `api/v1/POS/customOrder/getCatalogPdf`,
      );
      if (res.code === 200) {
        window.open(res?.url, "_blank");
        toast.success(res?.message || "PDF generated successfully");
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    if (pNavid) {
      navigate("/app/pos/catalog/CollectionList", {
        state: { navids: pNavid, filtertype: isCrown },
      });
    } else if (state?.parkid || state?.order_id) {
      GetCartdetailpark();
    }
    // eslint-disable-next-line
  }, [pNavid, state?.parkid]);

  useEffect(() => {
    localStorage.setItem("showcheckout", showcheckout);
  }, [showcheckout]);

  const scrollableDivRef = useRef(null);
  const [hasReachedEnd, setHasReachedEnd] = useState(false);

  const handleScroll = () => {
    if (shoremorelodar) return;

    const div = scrollableDivRef.current;
    if (div) {
      const { scrollTop, scrollHeight, clientHeight } = div;
      const CompleteScroll = scrollTop + clientHeight;

      if (CompleteScroll >= scrollHeight - 5) {
        if (!hasReachedEnd) {
          if (
            finalprodata?.length !== 0 &&
            skip + 20 <= Totalproduct &&
            shoremorelodar === false
          ) {
            setHasReachedEnd(true);
            setSkip((prevSkip) => prevSkip + 20);
            setShowmorelodar((prev) => (prev ? false : true));
          }
        }
      } else {
        setHasReachedEnd(false);
        setShowmorelodar(false);
      }
    }
  };

  useEffect(() => {
    if (isIcsTab) return;
    getproducts();
    // eslint-disable-next-line
  }, [skip, Sale, isCrown, customer?.id, isIcsTab]);

  const posScreenState = {
    setShowcheckout: setShowcheckout,
    setUpdatedCart: setUpdatedCart,
    UpdatedCart: UpdatedCart,
    setShowpayment: setShowpayment,
    showpayment: showpayment,
    setdeletestatus: setdeletestatus,
    setsearchproductstatus: setsearchproductstatus,
    searchproductstatus: true,
    parkid: state?.parkid,
    order_id: state?.order_id,
    ordertype: "pos_order",
    order_edit: state?.order_edit,
    order_type: state?.order_type,
    inv_orderid: inv_orderid,
    inv_ordertype: inv_ordertype,
    by_repair_order: by_repair_order,
    by_customorder: by_customorder,
    getproducts: getproducts,
    uuid: uuid,
    setCartstockid: setCartstockid,
    stock_id: stockid,
    showcheckout: "sell",
  };

  useEffect(() => {
    dispatch(updatePosState(posScreenState));
  }, [dispatch]);

  const renderLegacyHeader = () => (
    <div className="catalog-area-header-area-control">
      <div className="catalog-area-header-area-control-left">
        <button
          className={
            isCrown
              ? "catalog-area-header-area-control-left-btn warehouse"
              : "catalog-area-header-area-control-left-btn"
          }
          onClick={() => {
            crownClick();
            setSkip(0);
          }}
        >
          <img
            src={
              isCrown === false
                ? base_assets + "images/pos/icons/warehouse.png"
                : base_assets + "images/pos/icons/crown-outline.png"
            }
            alt=""
          />
        </button>
      </div>
      <div className="catalog-area-header-area-control-right">
        <div className="com-search-area">
          <button className="com-search-area-left-img">
            <img
              src={base_assets + "images/pos/icons/scan-icon.png"}
              alt=""
            />
          </button>
          <input
            type="text"
            value={searchsku}
            onKeyPress={(e) => e.key === "Enter" && filterbyname()}
            onChange={(e) => setSearchsku(e.target.value)}
            placeholder={t("Scan barcode, Search SKU")}
          />
          <img
            className="com-search-area-img"
            onClick={() => {
              filterbyname();
            }}
            src={base_assets + "images/pos/icons/magnifying-glass.png"}
            alt=""
          />
        </div>
        <div className="catalog-area-header-area-control-right-view dropdown">
          <button
            className=" dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              className="catalog-area-header-area-control-right-view-img"
              src={
                isviewOption
                  ? base_assets + "images/pos/icons/list-view-icon.png"
                  : base_assets + "images/pos/icons/grid-icon.png"
              }
              alt=""
            />
            <div className="catalog-area-header-area-control-right-view-arrow">
              <div className="catalog-area-header-area-control-right-view-arrow-img">
                <img
                  src={base_assets + "images/pos/icons/arrow-up.png"}
                  alt=""
                />
              </div>
              <div className="catalog-area-header-area-control-right-view-arrow-img">
                <img
                  src={base_assets + "images/pos/icons/arrow-down.png"}
                  alt=""
                />
              </div>
            </div>
          </button>
          <ul
            className="dropdown-menu"
            aria-labelledby="dropdownMenuButton1"
          >
            <li className="hover-effect">
              <Link
                className="dropdown-item hover-effect-inner hover-effect-inner"
                onClick={() => setIsviewOption(false)}
              >
                <img
                  className="catalog-area-header-area-control-right-view-img hover-effect-inner-img hover-effect-inner-img-g"
                  src={base_assets + "images/pos/icons/grid-icon.png"}
                  alt=""
                />
                <img
                  className="catalog-area-header-area-control-right-view-img hover-effect-inner-img hover-effect-inner-img-w"
                  src={
                    base_assets + "images/pos/icons/grid-icon-gray.png"
                  }
                  alt=""
                />
              </Link>
            </li>
            <li className="hover-effect">
              <Link
                className="dropdown-item hover-effect-inner hover-effect-inner"
                onClick={() => setIsviewOption(true)}
              >
                <img
                  className="catalog-area-header-area-control-right-view-img hover-effect-inner-img hover-effect-inner-img-g"
                  src={
                    base_assets + "images/pos/icons/list-view-icon.png"
                  }
                  alt=""
                />
                <img
                  className="catalog-area-header-area-control-right-view-img hover-effect-inner-img hover-effect-inner-img-w"
                  src={
                    base_assets +
                    "images/pos/icons/list-view-icon-gray.png"
                  }
                  alt=""
                />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  const renderLegacyProductArea = () => (
    <>
      <div
        className="catalog-area-ct bg-white"
        ref={scrollableDivRef}
        onScroll={handleScroll}
      >
        <div className="product-filter-bar">
          <div className="product-filter-bar-left common-select">
            <label className="product-filter-bar-left-label">
              {state?.itemname}
            </label>
            <div className="dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="graph"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  className=""
                  src={base_assets + "images/pos/icons/graph-icon.png"}
                  alt=""
                />
              </button>
              <ul className="dropdown-menu" aria-labelledby="graph">
                <li
                  className="dropdown-item"
                  onClick={() => setSale("top_sale")}
                >
                  <img
                    className=""
                    src={base_assets + "images/pos/icons/top-sale.png"}
                    alt=""
                  />{" "}
                  {t("Top sales")}
                </li>
                <li
                  className="dropdown-item"
                  onClick={() => setSale("lowest_sale")}
                >
                  <img
                    className=""
                    src={base_assets + "images/pos/icons/up-sale.png"}
                    alt=""
                  />{" "}
                  {t("lowest sales")}
                </li>
              </ul>
            </div>
          </div>
          <div style={{ cursor: downloading ? "not-allowed" : "pointer" }}>
            <button
              className="btn p-0 border-0 bg-transparent shadow-none"
              type="button"
              onClick={() => !downloading && setExportModalOpen(true)}
              disabled={downloading}
              style={{ lineHeight: 1 }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 4.99996L11.6464 4.64641L12 4.29285L12.3536 4.64641L12 4.99996ZM12.5 14C12.5 14.2761 12.2761 14.5 12 14.5C11.7239 14.5 11.5 14.2761 11.5 14H12.5ZM6.64648 9.64641L11.6464 4.64641L12.3536 5.35351L7.35358 10.3536L6.64648 9.64641ZM12.3536 4.64641L17.3536 9.64641L16.6464 10.3536L11.6464 5.35351L12.3536 4.64641ZM12.5 4.99996V14H11.5V4.99996H12.5Z"
                  fill="#606060"
                />
                <path
                  d="M5 16V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V16"
                  stroke="#606060"
                />
              </svg>
            </button>
          </div>
        </div>
        {custom_data?.length ||
        (productlist?.length && Loadingstatus === false) ? (
          isviewOption ? (
            <ProductListTable
              ProductListTable={productlist}
              filter={isCrown}
              setProductListTable={setProductlist}
              setShowcheckout={setShowcheckout}
              itemid={state?.itemid}
              NavId={state?.NavId}
              itemname={state?.itemname}
              setsearchproductstatus={setsearchproductstatus}
              setUpdatedCart={setUpdatedCart}
              parkid={state?.parkid}
              order_id={state?.order_id}
              order_edit={state?.order_edit}
              order_type={state?.order_type}
              customer_id={customer?.id}
              setInv_orderid={setInv_orderid}
              inv_orderid={inv_orderid}
              setInv_ordertype={setInv_ordertype}
              inv_ordertype={inv_ordertype}
              setBy_customorder={setBy_customorder}
              by_customorder={by_customorder}
              setBy_repair_order={setBy_repair_order}
              by_repair_order={by_repair_order}
              addparmission={addparmission}
              finalprodata={finalprodata}
              setUuid={setUuid}
              uuid={uuid}
              cartstockid={cartstockid}
              setStockid={setStockid}
            />
          ) : (
            <ProductListGrid
              ProductListGrid={productlist}
              setProductListGrid={setProductlist}
              filter={isCrown}
              setShowcheckout={setShowcheckout}
              itemid={state?.itemid}
              NavId={state?.NavId}
              itemname={state?.itemname}
              setsearchproductstatus={setsearchproductstatus}
              parkid={state?.parkid}
              order_id={state?.order_id}
              setUpdatedCart={setUpdatedCart}
              order_edit={state?.order_edit}
              order_type={state?.order_type}
              setInv_orderid={setInv_orderid}
              inv_orderid={inv_orderid}
              setInv_ordertype={setInv_ordertype}
              setBy_repair_order={setBy_repair_order}
              inv_ordertype={inv_ordertype}
              by_repair_order={by_repair_order}
              by_customorder={by_customorder}
              setBy_customorder={setBy_customorder}
              addparmission={addparmission}
              custom_data={custom_data}
              finalprodata={finalprodata}
              setUuid={setUuid}
              uuid={uuid}
              cartstockid={cartstockid}
              setStockid={setStockid}
            />
          )
        ) : productlist?.length === 0 ? (
          <NoOrdersYet />
        ) : (
          <Loading />
        )}
      </div>
      {shoremorelodar ? (
        <div
          className="border-bottom-0 d-block main-green-text mx-auto my-4 spinner-border flex-shrink-0"
          role="status"
        ></div>
      ) : (
        ""
      )}
    </>
  );

  const renderCheckoutPanel = () => (
    <div className="main-body-row-right-col">
      {showcheckout === "sell" ? (
        <CheckoutSell
          setShowcheckout={setShowcheckout}
          setUpdatedCart={setUpdatedCart}
          UpdatedCart={UpdatedCart}
          setShowpayment={setShowpayment}
          showpayment={showpayment}
          setdeletestatus={setdeletestatus}
          setsearchproductstatus={setsearchproductstatus}
          searchproductstatus={searchproductstatus}
          parkid={state?.parkid}
          order_id={state?.order_id}
          ordertype={"pos_order"}
          order_edit={state?.order_edit}
          order_type={state?.order_type}
          inv_orderid={inv_orderid}
          inv_ordertype={inv_ordertype}
          by_repair_order={by_repair_order}
          by_customorder={by_customorder}
          getproducts={isIcsTab ? undefined : getproducts}
          uuid={uuid}
          setCartstockid={setCartstockid}
          stock_id={stockid}
        />
      ) : showcheckout === "payment" ? (
        <CheckoutPayment
          UpdatedCart={UpdatedCart}
          setShowcheckout={setShowcheckout}
          order_edit={state?.order_edit}
          order_id={inv_orderid ? inv_orderid : state?.order_id}
          order_type={
            inv_ordertype === "custom_order"
              ? "pos_order"
              : inv_ordertype
                ? inv_ordertype
                : state?.order_type
          }
          by_custom_order={by_customorder}
          by_repair_order={by_repair_order}
        />
      ) : (
        <CheckoutBlank />
      )}
    </div>
  );

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div
              className={
                isIcsTab
                  ? "catalog-area catalog-area--all-products-tab"
                  : "catalog-area"
              }
            >
              <div className="catalog-area-header-area">
                <CatalogNavbar
                  setproductNavid={setproductNavid}
                  navid={state?.NavId}
                  location={"/app/pos/products"}
                  pNavid={pNavid}
                />
                {isIcsTab ? (
                  <CatalogProductsToolbarSection
                    isCrown={isCrown}
                    onCrownClick={crownClick}
                    categoryId={state?.NavId}
                    subCategoryId={state?.itemid}
                    subCategoryName={state?.itemname}
                    customer={customer}
                    onSetProductData={setproductdata}
                    appliedCatalogFilters={appliedCatalogFilters}
                    setAppliedCatalogFilters={setAppliedCatalogFilters}
                    isListView={icsListView}
                    setIsListView={setIcsListView}
                  />
                ) : (
                  renderLegacyHeader()
                )}
              </div>
              {isIcsTab ? (
                <div className="tab-content catalog-area-ct catalog-area-ct--all-products-grid">
                  <div className="h-100 tab-pane fade show active" id="jalwary">
                    <CatalogAllProducts
                      Optiondetails={isCrown}
                      customer={customer}
                      parkid={state?.parkid}
                      order_id={state?.order_id}
                      order_edit={state?.order_edit}
                      order_type={state?.order_type}
                      catalogNavId={state?.NavId}
                      itemId={state?.itemid}
                      categoryId={state?.NavId}
                      itemName={state?.itemname}
                      setShowcheckout={setShowcheckout}
                      setUpdatedCart={setUpdatedCart}
                      setsearchproductstatus={setsearchproductstatus}
                      saleFilter={sortByToSale(appliedCatalogFilters.sortBy)}
                      productFilters={appliedCatalogFilters}
                      isListView={icsListView}
                      productsReady={Boolean(state?.itemid)}
                    />
                  </div>
                </div>
              ) : (
                renderLegacyProductArea()
              )}
              <Link
                to="/app/pos/catalog/smart-search"
                state={{
                  fromProducts: true,
                  // isCrown true = catalog, false = inventory
                  filtertype: isCrown,
                  inStock: !isCrown,
                  productsState: {
                    NavId: state?.NavId,
                    itemid: state?.itemid,
                    itemname: state?.itemname,
                    parkid: state?.parkid,
                    order_id: state?.order_id,
                    order_edit: state?.order_edit,
                    order_type: state?.order_type,
                    Optiondetails: isCrown,
                  },
                }}
                className="catalog-area__faro-search"
                aria-label={t("FARO Search")}
                aria-disabled={!isFaroActive}
                onClick={handleFaroClick}
                style={!isFaroActive ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                // title={t("FARO Search")}
              >
                {/* <img src={faromainicon} alt="" aria-hidden /> */}
                <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto",marginTop:0 }}
        >
                <img src={faromainicon} alt="" aria-hidden />
                <span className="kycTooltip-area-up-text" style={{  minWidth:'32px',padding:'5px 5px',  bottom: 'calc(100% - -4px)'}}>faro</span>

              </div>
              </Link>
            </div>
          </div>
          {renderCheckoutPanel()}
        </div>
      </div>
      <ExportOptionModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onExport={downlodPrintPDF}
        loading={downloading}
      />
    </>
  );
};

export default Products;
